import { canUseDOM } from 'exenv';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import Sticky from 'react-stickynode';
import striptags from 'striptags';
import get from 'lodash/get';
import extend from 'lodash/extend';
import findIndex from 'lodash/findIndex';
import chunk from 'lodash/chunk';
import concat from 'lodash/concat';
import LoadingSpinner from '../../../../components/loading_spinner/loading_spinner';
import Social from '../../../../components/social/social';
import Image from '../../../../components/image/image';
import Slug from '../../../../components/slug/slug';
import Ad from '../../../../components/ad/ad';
import FCLink from '../../../../components/fc_link/fc_link';
import NotFound from '../../../../components/not_found_component/not_found_component';
import matchMediaDesktop from '../../../../../utils/client_util';
import { imageSizesLookup } from '../../../../../utils/cloudinary_asset_util';
import loadDataYear from './mic_year_page_state_manager';
import loadDataSector from './mic_sector_page_state_manager';

class MicYear2018 extends Component {
  static loadData(store) {
    const navHist = get(store.getState(), 'config.navHistory');
    const sector =
      get(navHist, `[${navHist.length - 1}]`, '').indexOf('sectors') > -1;
    if (sector) {
      return loadDataSector(store, '2018');
    }
    return loadDataYear(store, '2018');
  }

  constructor() {
    super();
    this.state = {
      mobileTop50Active: false,
      mobileSectorsActive: false,
      mobileSocialActive: false
    };

    this.enbaleSticky = false;
    this.toggleMobileMenu = this.toggleMobileMenu.bind(this);
    this.toggleMobileShareButtons = this.toggleMobileShareButtons.bind(this);
  }

  componentDidMount() {
    this.html = document.querySelector('html');

    const adData = get(this.props.micYearPage, 'ads');

    if (canUseDOM) {
      if (adData !== undefined) {
        // Update the data layer
        extend(window.digitalData.page.pageInfo, {
          adPath: `/4160/mv.fc/${adData.model.adzone}`
        });
      }
    }
  }

  componentDidUpdate() {
    this.pageScrolling();
  }

  getArraySplit(arr, items) {
    return chunk(arr, Math.ceil(arr.length / items));
  }

  pad(n) {
    return n < 10 ? `0${n}` : n;
  }

  strip(str) {
    return striptags(str, ['a', 'b', 'em', 'i', 'u', 'strike', 'strong']);
  }

  pageScrolling() {
    if (!this.html) return;
    const { mobileTop50Active, mobileSectorsActive } = this.state;
    const addRemove =
      mobileTop50Active || mobileSectorsActive ? 'add' : 'remove';
    this.html.classList[addRemove]('no-scroll');
  }

  toggleMobileMenu(isTop50) {
    const { mobileTop50Active, mobileSectorsActive } = this.state;
    this.setState({
      mobileTop50Active: isTop50 && !mobileTop50Active,
      mobileSectorsActive: !isTop50 && !mobileSectorsActive,
      mobileSocialActive: false
    });
  }

  closeMobileMenu() {
    this.setState({
      mobileTop50Active: false,
      mobileSectorsActive: false,
      mobileSocialActive: false
    });
  }

  toggleMobileShareButtons() {
    this.setState({
      mobileTop50Active: false,
      mobileSectorsActive: false,
      mobileSocialActive: !this.state.mobileSocialActive
    });
  }

  scrollToRankPosition(rank) {
    const menu = document.querySelector('.mic-2018__honoree-menu');
    const company = document.querySelector(`#company-${rank}`);

    menu.classList.add('close');
    window.scroll({
      top: company.offsetTop - 100,
      left: 0,
      behavior: 'smooth'
    });
    company.classList.add('mic-2018__company--selected');

    setTimeout(() => menu.classList.remove('close'), 500);
    setTimeout(
      () => company.classList.remove('mic-2018__company--selected'),
      3500
    );

    this.closeMobileMenu();
  }

  renderSectorPage(sector) {
    const { config, micSector } = this.props;
    const selectedSector = get(micSector, `[${this.activeIndex}]`, {});

    return (
      <section className="mic-year-page mic-year-page--2018">
        <Ad {...this.combinedAdModel} name="oop" slug={false} oop={true} />

        <div className="ad-container ad-container--gray ad-container--hide-for-small">
          <Ad
            {...this.combinedAdModel}
            name="flexiblebillboard_1"
            noLazyLoad={true}
          />
        </div>

        <div className="ad-container ad-container--hide-for-medium-up post__article-top-ad-wrapper">
          <Ad
            {...this.combinedAdModel}
            name="mobileleaderboard_short"
            noLazyLoad={true}
          />
        </div>

        <div className="mic-2018__sector">
          <div className="mic-2018__sector-social">
            <Social
              empty={false}
              enableSticky={false}
              uri={`https://www.fastcompany.com/most-innovative-companies/2018/sectors/${sector}`}
              text={encodeURIComponent(
                `@FastCompany's Most Innovative Companies 2018 Honorees By Sector: ${
                  selectedSector.name
                } #FCMostInnovative`
              )}
            />
          </div>
          <div className="mic-2018__sector-content">
            <div className="mic-2018__sector-header">
              <h1>
                THE WORLD’S <span>MOST INNOVATIVE</span> COMPANIES{' '}
                <span>2018</span> HONOREES BY SECTOR
              </h1>
            </div>
            <Slug
              slugName={get(micSector, `[${this.activeIndex}].name`, '')}
              canUpdate={true}
            />
            <div className="mic-2018__sector-group">
              <div className="mic-2018__sectors">
                {this.getArraySplit(micSector, 2).map((sectorsSplit, index) => (
                  <ul
                    key={`sector-page-list-${index}`}
                    className="mic-2018__list"
                  >
                    {sectorsSplit.map(sec => (
                      <li
                        key={`sector-page-item-${sec.url}`}
                        className={sector === sec.url ? 'active' : ''}
                      >
                        {sector === sec.url ? (
                          sec.name
                        ) : (
                          <FCLink
                            config={config}
                            to={`https://fastcompany.com/most-innovative-companies/2018/sectors/${
                              sec.url
                            }`}
                          >
                            {sec.name}
                          </FCLink>
                        )}
                      </li>
                    ))}
                  </ul>
                ))}
              </div>
              <div className="mic-2018__sector-companies">
                {this.getArraySplit(micSector[this.activeIndex].list, 2).map(
                  (companies, splitIndex) => (
                    <div
                      key={`sector-page-rank-col-${splitIndex}`}
                      className="mic-2018__rank-col"
                    >
                      {companies.map((company, companyIndex) => (
                        <div
                          className="mic-2018__rank-company"
                          key={`${company.url}-${splitIndex}-${companyIndex}`}
                        >
                          <FCLink
                            config={config}
                            to={`/company/${company.url}`}
                          >
                            <span>
                              {this.pad(companyIndex + 1 + splitIndex * 5)}
                            </span>{' '}
                            <h2>{company.name}</h2>
                            <p>{company.for}</p>
                          </FCLink>
                        </div>
                      ))}
                    </div>
                  )
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="mic-2018__back-to-year">
          <a href="/most-innovative-companies/2018">Back To</a>
        </div>
        <div className="ad-container">
          <Ad
            {...this.combinedAdModel}
            name="flexiblebillboard_2"
            noLazyLoad={true}
          />
          <Ad
            {...this.combinedAdModel}
            name="mobilerectangle_1"
            noLazyLoad={true}
          />
        </div>
        {this.renderMobileNav(sector)}
      </section>
    );
  }

  renderTop50() {
    const { micYear } = this.props;

    if (canUseDOM) {
      this.enbaleSticky = matchMediaDesktop();
    }

    return (
      <section className="mic-year-page mic-year-page--2018">
        <Ad {...this.combinedAdModel} name="oop" slug={false} oop={true} />

        <div className="ad-container ad-container--gray ad-container--hide-for-small">
          <Ad
            {...this.combinedAdModel}
            name="flexiblebillboard_1"
            noLazyLoad={true}
          />
        </div>

        <div className="ad-container ad-container--hide-for-medium-up post__article-top-ad-wrapper">
          <Ad
            {...this.combinedAdModel}
            name="mobileleaderboard_short"
            noLazyLoad={true}
          />
        </div>
        <div className="mic-2018__wrapper">
          {this.renderDesktopNav()}
          <div className="mic-2018__content-container">
            {micYear.map((compaines, yearIndex) => (
              <div className="mic-2018__group" key={`compaines-${yearIndex}`}>
                <div className="mic-2018__main-col">
                  {!yearIndex ? this.renderHeader() : null}
                  {this.renderCompanies(compaines)}
                </div>
                <div
                  className="mic-2018__sidebar"
                  id={`mic-2018-sidebar-${yearIndex}`}
                >
                  {/* eslint-disable no-nested-ternary */}
                  <Sticky
                    top={100}
                    bottomBoundary={`#mic-2018-sidebar-${yearIndex}`}
                    enabled={this.enbaleSticky}
                  >
                    <Ad
                      {...this.combinedAdModel}
                      pos="atf"
                      name="flexibleportrait"
                      canRefresh={true}
                      pageNum={1}
                    />
                  </Sticky>
                </div>
              </div>
            ))}
          </div>
          {this.renderHonorees()}
        </div>
        <div className="ad-container">
          <Ad
            {...this.combinedAdModel}
            name="flexiblebillboard_2"
            noLazyLoad={true}
          />
          <Ad
            {...this.combinedAdModel}
            name="mobilerectangle_1"
            noLazyLoad={true}
          />
        </div>
        {this.renderMobileNav()}
      </section>
    );
  }

  renderDesktopNav() {
    const { config, micYear, micSector } = this.props;
    const firstSector = get(micSector, '[0]', {});

    return (
      <div className="mic-2018__nav" id="mic-2018-nav">
        {/* eslint-disable no-nested-ternary */}
        <Sticky
          top={100}
          bottomBoundary="#mic-2018-nav"
          enabled={this.enbaleSticky}
        >
          <Social
            empty={false}
            enableSticky={false}
            modifier="mic-2018"
            uri="https://www.fastcompany.com/most-innovative-companies/2018/"
            text={encodeURIComponent(
              `@FastCompany's Most Innovative Companies 2018 #FCMostInnovative`
            )}
          />

          <div className="mic-2018__honoree-menu">
            <span>Honorees By Rank</span>
            <div className="mic-2018__honoree-menu-panel">
              {this.getArraySplit(concat(...micYear), 3).map(
                (rankSplit, index) => (
                  <ul key={`company-rank-list-${index}`}>
                    {rankSplit.map(company => (
                      <li
                        key={`company-rank-${company.ranking}`}
                        onClick={() =>
                          this.scrollToRankPosition(company.ranking)
                        }
                      >
                        <span>{this.pad(company.ranking)}</span> {company.name}
                      </li>
                    ))}
                  </ul>
                )
              )}
            </div>
          </div>
          <FCLink
            config={config}
            to={`/most-innovative-companies/2018/sectors/${firstSector.url}`}
          >
            Honorees By Sector
          </FCLink>

          <a
            href="https://www.fastcompany.com/apply/most-innovative-companies?utm_source=fastcompanywebsite&utm_medium=honoreelist&utm_campaign=062018"
            className="mic-2018__apply"
          >
            APPLY FOR MIC
          </a>
        </Sticky>
      </div>
    );
  }

  renderMobileNav(sector) {
    const { config, micYear, micSector } = this.props;
    const {
      mobileTop50Active,
      mobileSectorsActive,
      mobileSocialActive
    } = this.state;
    const top50 = concat(...micYear);
    const rankLink = () => {
      if (sector) {
        return (
          <div className="mic-2018__mobile-item">
            <FCLink config={config} to="/most-innovative-companies/2018">
              Top 50
            </FCLink>
          </div>
        );
      }

      return (
        <div
          className="mic-2018__mobile-item"
          onClick={() => this.toggleMobileMenu(true, mobileTop50Active, false)}
        >
          Top 50
        </div>
      );
    };
    const sectorLink = () => (
      <div
        className="mic-2018__mobile-item"
        onClick={() => this.toggleMobileMenu(false, false, mobileSectorsActive)}
      >
        Top 10<span>s</span>
      </div>
    );
    const closeBtn = () => (
      <div
        className="mic-2018__mobile-close"
        onClick={() => this.closeMobileMenu()}
      />
    );

    return (
      <div className="mic-2018__mobile-nav">
        <div className="mic-2018__mobile-item-container">
          {rankLink()}
          {sectorLink()}
          <div
            className="mic-2018__mobile-item mic-2018__mobile-item--share"
            onClick={() => this.toggleMobileShareButtons()}
          >
            <i className="icon-video-share" />
          </div>
        </div>
        <div
          className={`mic-2018__mobile-list ${
            mobileTop50Active ? 'mic-2018__mobile-list--active' : ''
          }`}
        >
          <h3 className="mic-2018__mobile-title">
            Most Innovative Companies 2018
          </h3>
          {closeBtn()}
          <ul
            className={`mic-2018__list ${
              mobileTop50Active ? 'mic-2018__list--active' : ''
            }`}
          >
            {top50.map(company => (
              <li
                key={`mobile-nav-50-${company.url}`}
                onClick={() => this.scrollToRankPosition(company.ranking)}
              >
                <span>{this.pad(company.ranking)}</span> {company.name}
              </li>
            ))}
          </ul>
        </div>

        <div
          className={`mic-2018__mobile-list ${
            mobileSectorsActive ? 'mic-2018__mobile-list--active' : ''
          }`}
        >
          <h3 className="mic-2018__mobile-title">
            Most Innovative Companies 2018
          </h3>
          {closeBtn()}
          <ul
            className={`mic-2018__list ${
              mobileSectorsActive ? 'mic-2018__list--active' : ''
            }`}
          >
            {micSector.map(sec => (
              <li
                key={`mobile-nav-sector-${sec.url}`}
                onClick={() => this.closeMobileMenu()}
              >
                <FCLink
                  config={config}
                  to={`https://fastcompany.com/most-innovative-companies/2018/sectors/${
                    sec.url
                  }`}
                >
                  {sec.name}
                </FCLink>
              </li>
            ))}
          </ul>
        </div>

        <div
          className={`mic-2018__mobile-social ${
            mobileSocialActive ? 'mic-2018__mobile-social--active' : ''
          }`}
        >
          <Social
            empty={false}
            enableSticky={false}
            modifier="mic-2018"
            uri="https://www.fastcompany.com/most-innovative-companies/2018/"
            text={encodeURIComponent(
              `@FastCompany's Most Innovative Companies 2018 #FCMostInnovative`
            )}
          />
        </div>
      </div>
    );
  }

  renderHeader() {
    const { micYearDescription } = this.props;

    return (
      <div className="mic-2018__header">
        <h2>
          <img
            src="https://images.fastcompany.net/image/upload/v1516119147/fcweb/MIC-2018-Logo-50-16x9_jgujif.gif"
            alt={micYearDescription.description}
          />
          <span>{micYearDescription.description}</span>
        </h2>
        <div
          dangerouslySetInnerHTML={{
            __html: micYearDescription.intro
          }}
        />
      </div>
    );
  }

  renderCompanies(compaines) {
    const { config } = this.props;

    return (
      <div className="mic-2018__companies">
        {compaines.map(company => (
          <div
            key={`company-${company.ranking}`}
            id={`company-${company.ranking}`}
            className={`mic-2018__company ${
              company.media && company.media_orientation === 'landscape'
                ? 'mic-2018__company--landscape'
                : ''
            }`}
          >
            <div className="mic-2018__company-info">
              <FCLink config={config} to={`/company/${company.url}`}>
                <span>{this.pad(company.ranking)}</span> <h3>{company.name}</h3>
              </FCLink>
              {company.media ? (
                <p className="mic-2018__why">{company.why}</p>
              ) : null}
              {!company.media ||
              (company.media && company.media_orientation === 'portrait') ? (
                <ul>
                  <li>
                    <FCLink config={config} to={`/company/${company.url}`}>
                      Company Profile
                    </FCLink>
                  </li>
                  {company.related_article ? (
                    <li>
                      <FCLink config={config} to={company.related_article}>
                        Read Article
                      </FCLink>
                    </li>
                  ) : null}
                </ul>
              ) : null}
            </div>
            <div className="mic-2018__company-content">
              {company.media ? (
                [
                  <Image
                    key={`image-${company.url}`}
                    src={company.media}
                    alt={company.caption}
                    assetSizes={imageSizesLookup.mic2018Landscape}
                    noLazy={true}
                  />,
                  <p
                    key={`caption-${company.url}`}
                    className="mic-2018__caption"
                    dangerouslySetInnerHTML={{
                      __html: this.strip(
                        `${company.caption} [${company.credits}]`
                      )
                    }}
                  />
                ]
              ) : (
                <p className="mic-2018__why mic-2018__why--inline">
                  {company.why}
                </p>
              )}
              <ul>
                <li>
                  <FCLink config={config} to={`/company/${company.url}`}>
                    Company Profile
                  </FCLink>
                </li>
                {company.related_article ? (
                  <li>
                    <FCLink config={config} to={company.related_article}>
                      Read Article
                    </FCLink>
                  </li>
                ) : null}
              </ul>
            </div>
          </div>
        ))}
      </div>
    );
  }

  renderHonorees() {
    const { config, micSector } = this.props;
    const firstSector = get(micSector, '[0]', {});

    return (
      <div className="mic-2018__honorees-by-sectors">
        <div className="mic-2018__sector-header">
          <h1>
            <FCLink
              config={config}
              to={`/most-innovative-companies/2018/sectors/${firstSector.url}`}
            >
              THE WORLD’S <span>MOST INNOVATIVE</span> COMPANIES{' '}
              <span>2018</span> HONOREES BY SECTOR
            </FCLink>
          </h1>
        </div>
        {this.getArraySplit(micSector, 4).map((sectorsSplit, index) => (
          <ul key={`sectors-list-${index}`}>
            {sectorsSplit.map(sec => (
              <li key={`sector-${sec.url}`}>
                <FCLink
                  config={config}
                  to={`https://fastcompany.com/most-innovative-companies/2018/sectors/${
                    sec.url
                  }`}
                >
                  {sec.name}
                </FCLink>
              </li>
            ))}
          </ul>
        ))}
      </div>
    );
  }

  render() {
    const { match, status, micYearPage, micSector } = this.props;
    const sector = get(match, 'params.sector');

    this.activeIndex = -1;

    if (sector) {
      this.activeIndex = findIndex(micSector, sec => sec.url === sector);
    }

    if (
      this.props.micYearPage.error ||
      status === 404 ||
      (sector && this.activeIndex < 0)
    ) {
      return (
        <section className="tag-page">
          <article className="tag-page__main--error-pg">
            <NotFound />
          </article>
        </section>
      );
    }

    if (this.props.micYearPage.isLoading === false) {
      const adData = get(micYearPage, 'ads');
      this.combinedAdModel = extend(
        {},
        { baseConfig: get(adData, 'config.baseConfig') },
        { definitions: get(adData, 'config.definitions') },
        { model: get(adData, 'model') }
      );

      if (sector) {
        return this.renderSectorPage(sector);
      }

      return this.renderTop50();
    }

    return <LoadingSpinner />;
  }
}

function mapStateToProps(state = {}) {
  const micData = chunk(get(state, 'micYear.data.rows'), 10);
  const micYearDesc = get(state, 'micYearDescription.data.rows[0]');
  return {
    config: state.config || {},
    status: state.status.code,
    micYearPage: Object.keys(get(state, 'micYearPage')).length
      ? state.micYearPage
      : get(state, 'micSectorPage') || { error: true },
    micYear: micData || { error: true },
    year: get(state, 'micYear.year'),
    micSector: get(state, 'micSector.data.rows', []),
    micYearDescription: micYearDesc || { error: true }
  };
}

MicYear2018.propTypes = {
  config: PropTypes.shape({}).isRequired,
  status: PropTypes.number,
  match: PropTypes.shape({}).isRequired,
  micYearPage: PropTypes.shape({
    ads: PropTypes.object,
    isLoading: PropTypes.bool,
    error: PropTypes.bool,
    errorMessage: PropTypes.string
  }),
  year: PropTypes.string,
  micYear: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.shape({}))).isRequired,
  micYearDescription: PropTypes.shape({
    logo_url: PropTypes.string,
    intro: PropTypes.string
  }),
  micSector: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};

MicYear2018.defaultProps = {
  status: 200,
  micYearPage: PropTypes.shape({
    isLoading: false,
    error: false,
    errorMessage: 'Error in micYearPage Props'
  }),
  year: '',
  micYearDescription: PropTypes.shape({
    logo_url: '',
    intro: ''
  })
};

export default withRouter(connect(mapStateToProps)(MicYear2018));
